import { render, staticRenderFns } from "./VideoCallDialog.vue?vue&type=template&id=3b54320b&scoped=true"
import script from "./VideoCallDialog.vue?vue&type=script&lang=js"
export * from "./VideoCallDialog.vue?vue&type=script&lang=js"
import style0 from "./VideoCallDialog.vue?vue&type=style&index=0&id=3b54320b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b54320b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b54320b')) {
      api.createRecord('3b54320b', component.options)
    } else {
      api.reload('3b54320b', component.options)
    }
    module.hot.accept("./VideoCallDialog.vue?vue&type=template&id=3b54320b&scoped=true", function () {
      api.rerender('3b54320b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/videoCall/VideoCallDialog.vue"
export default component.exports